"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFissionActivity = addFissionActivity;
exports.addScalperWhitelist = addScalperWhitelist;
exports.clearScalperCache = clearScalperCache;
exports.copyFissionActivity = copyFissionActivity;
exports.deleteScalperWhitelist = deleteScalperWhitelist;
exports.exportFissionActivity = exportFissionActivity;
exports.queryFissionActivity = queryFissionActivity;
exports.queryFissionActivityPage = queryFissionActivityPage;
exports.queryFissionActivityResendHelper = queryFissionActivityResendHelper;
exports.queryFissionActivityResendInitiator = queryFissionActivityResendInitiator;
exports.queryFissionStatisticsPage = queryFissionStatisticsPage;
exports.queryFissionTraffic = queryFissionTraffic;
exports.queryScalperWhitelistMember = queryScalperWhitelistMember;
exports.queryScalperWhitelistPage = queryScalperWhitelistPage;
exports.saveFissionTraffic = saveFissionTraffic;
exports.syncScalperCache = syncScalperCache;
exports.updateFissionActivity = updateFissionActivity;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var request_api_prefix = '/xyFissionActivity';
/**
 * 裂变活动 导出数据
 * @param helperIdd 发起者ID
 * @returns {Object}
 */
function exportFissionActivity(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/activityStatisticExport',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

/**
 * 裂变活动 助力者补发优惠券
 * @param helperIdd 发起者ID
 * @returns {Object}
 */
function queryFissionActivityResendHelper(helperIdd) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/resend/helper/' + helperIdd,
    method: 'get'
  });
}

/**
 * 裂变活动 发布者补发优惠券
 * @param params 查询参数
 * @returns {Object}
 */
function queryFissionActivityResendInitiator(initiatorIdd) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/resend/initiator/' + initiatorIdd,
    method: 'get'
  });
}

/**
 * 裂变活动 统计分页
 */
function queryFissionStatisticsPage(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/statistics/page',
    method: 'get',
    params: params
  });
}

/**
 * 裂变活动 拷贝创建
 * @param params 查询参数
 * @returns {Object}
 */
function copyFissionActivity(id) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/copy/' + id,
    method: 'get'
  });
}

/**
 * 分页查询裂变活动分页
 * @param params 查询参数
 * @returns {Object}
 */
function queryFissionActivityPage(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/page',
    method: 'get',
    params: params
  });
}

/**
 * 根据ID查询裂变活动
 * @param id 裂变活动ID
 * @returns {Object}
 */
function queryFissionActivity(id) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/' + id,
    method: 'get'
  });
}

/**
 * 添加裂变活动
 * @param data 裂变活动数据
 * @returns {Object}
 */
function addFissionActivity(data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix,
    method: 'post',
    data: data
  });
}

/**
 * 修改裂变活动
 * @param id 裂变活动ID
 * @param data 裂变活动数据
 * @returns {Object}
 */
function updateFissionActivity(id, data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/' + id,
    method: 'put',
    data: data
  });
}

/** 黄牛白名单分页 */
function queryScalperWhitelistPage(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/scalperWhitelist/page',
    method: 'get',
    params: params
  });
}

/** 按用户ID/手机号/卡号查询会员 */
function queryScalperWhitelistMember(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/scalperWhitelist/member',
    method: 'get',
    params: params
  });
}

/** 新增黄牛白名单 */
function addScalperWhitelist(data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/scalperWhitelist',
    method: 'post',
    data: data
  });
}

/** 删除黄牛白名单 */
function deleteScalperWhitelist(id) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/scalperWhitelist/' + id,
    method: 'delete'
  });
}

/** 从 CDP 同步黄牛名单到 Redis（永不过期） */
function syncScalperCache() {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/scalperCache/sync',
    method: 'post',
    timeout: 120000
  });
}

/** 清除 Redis 黄牛数据（活动结束后手动） */
function clearScalperCache() {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/scalperCache',
    method: 'delete'
  });
}

/** 查询全局流量监控配置 */
function queryFissionTraffic() {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/traffic',
    method: 'get'
  });
}

/** 保存全局流量监控配置（关闭此配置 / 全拦所有活动发起和助力 / 限流） */
function saveFissionTraffic(data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/traffic',
    method: 'put',
    data: data
  });
}